import { Avatar, Badge, Box, Button, Card, CardBody, CardHeader, CircularProgress, CircularProgressLabel, Flex, Grid, Hide, Icon, Image, Progress, SimpleGrid, Skeleton, Spacer, Stack, Stat, StatHelpText, StatLabel, StatNumber, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, useColorModeValue, useToast } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { BsArrowRight, BsPersonVcardFill } from 'react-icons/bs';
import { FaUserTie } from 'react-icons/fa';
import { FaUserGroup } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import IconBox from '../../components/Icons/IconBox';
import { CartIcon, DocumentIcon, GlobeIcon, RocketIcon, StatsIcon, WalletIcon } from '../../components/Icons/Icons.js';
import { IoCheckmarkDoneCircleSharp, IoDocument, IoEllipsisHorizontal } from 'react-icons/io5';
import { BiHappy } from 'react-icons/bi';
import { LuPackageX } from "react-icons/lu";
import { TbTruckDelivery, TbTruckReturn } from "react-icons/tb";
import empty from '../../assets/images/empty.png';


import LineChart from '../../components/Charts/LineChart';
import axiosClient, { linkImage } from '../../axios-client.js';
import { useStateContext } from '../../context/ContextProvider.jsx';
import { Bar } from 'react-chartjs-2';
import {
	Chart as ChartJS,
	BarElement,
	CategoryScale,
	LinearScale,
	Tooltip,
	Legend,
} from "chart.js";

import { MdOutlineAddShoppingCart } from 'react-icons/md';
import SimplePagination from '../../components/SimplePagination.jsx';
import MyPagination from '../../components/MyPagination.jsx';
ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

function Dashboard() {
	const { t } = useTranslation();
	const { user, setUser, setToken, currentBusiness } = useStateContext()
	const navigate = useNavigate()
	const [usersOldCount, setUsersOldCount] = useState()
	const [usersNewCount, setUsersNewCount] = useState()


	const [countLivreThisMonth, setCountLivreThisMonth] = useState(0)

	const [commandesOldCount, setCommandesOldCount] = useState()
	const [commandesNewCount, setCommandesNewCount] = useState()

	const [productsOldCount, setProductsOldCount] = useState()
	const [productsNewCount, setProductsNewCount] = useState()

	const [ticketsOldCount, setTicketsOldCount] = useState()
	const [ticketsNewCount, setTicketsNewCount] = useState()

	const [top10Products, setTop10products] = useState([])
	const [currentPage, setCurrentPage] = useState(0);
	const [currentPageTop10, setCurrentPageTop10] = useState(0);

	const [paginationData, setPaginationData] = useState()
	const [loadingData, setLoadingData] = useState(true)
	const [checkLengthData, setCheckLengthData] = useState(false)
	const [commandes, setCommandes] = useState([])

	const [countNew, setCountNew] = useState()
	const [countAnnule, setCountAnnule] = useState()
	const [countLivre, setCountLivre] = useState()
	const [countRetour, setCountRetour] = useState()

	const [revenus, setRevenus] = useState([])
	const [charges, setCharges] = useState([])
	const [exchangeRate, setExchangeRate] = useState(1);

	const toast = useToast();

	////////////////////////////////the size of the table//////////////////////////////
	const PAGE_SIZE = 4;
	const [pageSize, setPageSize] = useState(PAGE_SIZE);
	const [pageSizeTop10, setPageSizeTop10] = useState(PAGE_SIZE);
	const handlePageSizeChange = (event) => {
		const newSize = parseInt(event.target.value, 10);
		setPageSize(newSize);
		setCurrentPage(0);
	};
	//////////////////////////////////////////////////////////////////////////////////


	const fetchBarData = (userId, userRole) => {

		axiosClient.get(`/commandes/getCommandesCount/?client=${userId}&userRole=${userRole}&business=${currentBusiness?.id}`)
			.then((res) => {
				setCountNew(res.data.count_new);

				setCountLivre(res.data.count_livre);
				setCountRetour(res.data.count_retourne);
				setCountAnnule(res.data.count_annule);

				if (res.data.error === 'Client is disabled.' && res.data.etat === false) {
					setUser({});
					setToken(null);
					localStorage.removeItem("tokenExpirationTime");
					localStorage.removeItem("refreshTimeAdmin");
					localStorage.removeItem("role");

					// Vérifier si le toast n'est pas déjà affiché
					if (!toast.isActive('accountDisabled')) {
						toast({
							id: 'accountDisabled',
							description: t("le compte est désactivé"),
							status: 'warning',
							variant: 'left-accent',
							duration: 2000,
							isClosable: true,
							position: 'bottom-right'
						});
					}
				}
			})
			.catch((error) => {
				// // console.error(error);
			});

	}

	// const fetchRevenusAndCharges = () => {
	// 	axiosClient.get('/commandes/getRevenusByMonth/')
	// 		.then((res) => {
	// 			setRevenus(res.data);
	// 		})
	// 		.catch((error) => {
	// 			// console.error(error);
	// 		});

	// 	axiosClient.get(`/charges/getChargesByMonth/?client=${user.id}`)
	// 		.then((res) => {
	// 			setCharges(res.data);
	// 		})
	// 		.catch((error) => {
	// 			// console.error(error);
	// 		});

	// }
	const fetchRevenus = async (userId, userRole) => {
		try {
			const res = await axiosClient.get(`/commandes/getRevenusByMonth/?client=${userId}&userRole=${userRole}&business=${currentBusiness?.id}`);
			if (res.data.error === 'Client is disabled.' && res.data.etat === false) {
				setUser({});
				setToken(null);
				localStorage.removeItem("tokenExpirationTime");
				localStorage.removeItem("refreshTimeAdmin");
				localStorage.removeItem("role");

				// Vérifier si le toast n'est pas déjà affiché
				if (!toast.isActive('accountDisabled')) {
					toast({
						id: 'accountDisabled',
						description: t("le compte est désactivé"),
						status: 'warning',
						variant: 'left-accent',
						duration: 2000,
						isClosable: true,
						position: 'bottom-right'
					});
				}
			}
			return res.data;
		} catch (error) {
			// // console.error('Error fetching revenus:', error);
			return null; // Or handle error according to your requirements
		}
	};

	const fetchCharges = async (userId, userRole) => {
		try {
			const res = await axiosClient.get(`/charges/getChargesByMonth/?client=${userId}&userRole=${userRole}&business=${currentBusiness?.id}`);

			if (res.data.error === 'Client is disabled.' && res.data.etat === false) {
				setUser({});
				setToken(null);
				localStorage.removeItem("tokenExpirationTime");
				localStorage.removeItem("refreshTimeAdmin");
				localStorage.removeItem("role");

				// Vérifier si le toast n'est pas déjà affiché
				if (!toast.isActive('accountDisabled')) {
					toast({
						id: 'accountDisabled',
						description: t("le compte est désactivé"),
						status: 'warning',
						variant: 'left-accent',
						duration: 2000,
						isClosable: true,
						position: 'bottom-right'
					});
				}
			}
			return res.data;
		} catch (error) {
			// // console.error('Error fetching charges:', error);
			return null; // Or handle error according to your requirements
		}
	};

	const labels = [t("Nouveau"), t("Livrée"), t("Retournée"), t("Annulée")];

	const dataChart = {
		labels: labels,
		datasets: [
			{
				label: "",
				data: [countNew, countLivre, countRetour, countAnnule],
				backgroundColor: [
					"rgba(54, 162, 235, 0.2)",
					"rgba(153, 102, 255, 0.2)",
					"rgba(246, 173, 85, 0.2)",
					"rgba(255, 99, 132, 0.2)",
				],
				borderColor: [
					"rgb(54, 162, 235)",
					"rgba(153, 102, 255)",
					"rgba(246, 173, 85)",
					"rgb(255, 99, 132)",

				],
				borderWidth: 1,
			},
		],
	};
	const options = {
		plugins: {
			title: {
				display: true,
				text: 'Orders Chart',
				font: {
					size: 16,
				},
			},
			legend: {
				display: false
			},
			tooltip: {
				callbacks: {
					label: function (context) {
						let label = context.dataset.label || '';
						if (label) {
							label += ': ';
						}
						if (context.parsed.y !== null) {
							label += context.parsed.y.toFixed(2);
						}
						return label;
					}
				}
			}
		},
		scales: {
			y: {
				ticks: {
					callback: function (value) {
						return value.toFixed(2);
					}
				}
			}
		}
	};


	const lineChartDataDashboard = async () => {
		const revenusData = await fetchRevenus(user.id, user?.role);
		const chargesData = await fetchCharges(user?.id, user?.role);

		const orderCur = currentBusiness?.order_currency?.toLowerCase();
		const sysCur = currentBusiness?.currency?.toLowerCase();
		let rate = 1;

		if (orderCur && sysCur && orderCur !== sysCur) {
			if (currentBusiness?.exchange_rate_type === 'Manual' && currentBusiness?.custom_exchange_rate) {
				rate = parseFloat(currentBusiness.custom_exchange_rate);
			} else {
				try {
					const rateRes = await fetch(`https://latest.currency-api.pages.dev/v1/currencies/${orderCur}.json`);
					const rateData = await rateRes.json();
					rate = rateData?.[orderCur]?.[sysCur] || 1;
				} catch (e) {
					// // console.error('Erreur API taux de change:', e);
				}
			}
		}
		setExchangeRate(rate);

		return [
			{
				name: t("Revenus"),
				data: (revenusData || []).map(val => val * rate),
			},
			{
				name: "Charges",
				data: (chargesData || []).map(val => val * rate),
			},
		];
	};

	const lineChartOptionsDashboard = {
		chart: {
			toolbar: {
				show: false,
			},
		},
		tooltip: {
			theme: "dark",
			y: {
				formatter: function (val) {
					return val.toFixed(2);
				},
			},
		},
		dataLabels: {
			enabled: false,
		},
		stroke: {
			curve: "smooth",
		},
		xaxis: {
			type: "datetime",
			categories: [
				"Jan",
				t("Fév"),
				"Mar",
				t("Avr"),
				t("Mai"),
				t("Jui"),
				t("Juil"),
				t("Aou"),
				"Sep",
				"Oct",
				"Nov",
				"Dec",
			],
			labels: {
				style: {
					colors: "darkgray",
					fontSize: "12px",
				},
			},
			axisBorder: {
				show: false,
			},
			axisTicks: {
				show: false,
			},
		},
		yaxis: {
			labels: {
				style: {
					colors: "darkgray",
					fontSize: "12px",
				},
				formatter: function (val) {
					return val.toFixed(2);
				},
			},
		},
		legend: {
			show: false,
		},
		grid: {
			strokeDashArray: 5,
			borderColor: "gray"
		},
		fill: {
			type: "gradient",
			gradient: {
				shade: "dark",
				type: "vertical",
				shadeIntensity: 0,
				gradientToColors: undefined, // optional, if not defined - uses the shades of same color in series
				inverseColors: true,
				opacityFrom: 0.8,
				opacityTo: 0,
				stops: [],
			},
			colors: ["#582CFF", "#ff7b7b"],
		},
		colors: ["#582CFF", "#ff7b7b"],
	};

	const fetchData = () => {
		axiosClient.get(`count_users/${user.id}/?business=${currentBusiness?.id}`)
			.then((response) => {

				if (response.data.error === 'Client is disabled.' && response.data.etat === false) {
					setUser({});
					setToken(null);
					localStorage.removeItem("tokenExpirationTime");
					localStorage.removeItem("refreshTimeAdmin");
					localStorage.removeItem("role");

					// Vérifier si le toast n'est pas déjà affiché
					if (!toast.isActive('accountDisabled')) {
						toast({
							id: 'accountDisabled',
							description: t("le compte est désactivé"),
							status: 'warning',
							variant: 'left-accent',
							duration: 2000,
							isClosable: true,
							position: 'bottom-right'
						});
					}
					return;
				}

				setUsersOldCount(response.data.old_count);
				setUsersNewCount(response.data.new_count);
			})
			.catch((error) => {
				// console.log(error);
			});

		axiosClient.get(`count_commandes/${user.id}/?business=${currentBusiness?.id}`)
			.then((response) => {

				if (response.data.error === 'Client is disabled.' && response.data.etat === false) {
					setUser({});
					setToken(null);
					localStorage.removeItem("tokenExpirationTime");
					localStorage.removeItem("refreshTimeAdmin");
					localStorage.removeItem("role");

					// Vérifier si le toast n'est pas déjà affiché
					if (!toast.isActive('accountDisabled')) {
						toast({
							id: 'accountDisabled',
							description: t("le compte est désactivé"),
							status: 'warning',
							variant: 'left-accent',
							duration: 2000,
							isClosable: true,
							position: 'bottom-right'
						});
					}
					return;
				}

				setCommandesOldCount(response.data.old_count);
				setCommandesNewCount(response.data.new_count);
			})
			.catch((error) => {
				// console.log(error);
			});

		axiosClient.get(`count_products/${user.id}/?business=${currentBusiness?.id}`)
			.then((response) => {

				if (response.data.error === 'Client is disabled.' && response.data.etat === false) {
					setUser({});
					setToken(null);
					localStorage.removeItem("tokenExpirationTime");
					localStorage.removeItem("refreshTimeAdmin");
					localStorage.removeItem("role");

					// Vérifier si le toast n'est pas déjà affiché
					if (!toast.isActive('accountDisabled')) {
						toast({
							id: 'accountDisabled',
							description: t("le compte est désactivé"),
							status: 'warning',
							variant: 'left-accent',
							duration: 2000,
							isClosable: true,
							position: 'bottom-right'
						});
					}
					return;
				}

				setProductsOldCount(response.data.old_count);
				setProductsNewCount(response.data.new_count);
			})
			.catch((error) => {
				// console.log(error);
			});
		axiosClient.get(`count_tickets/${user.id}/`)
			.then((response) => {

				if (response.data.error === 'Client is disabled.' && response.data.etat === false) {
					setUser({});
					setToken(null);
					localStorage.removeItem("tokenExpirationTime");
					localStorage.removeItem("refreshTimeAdmin");
					localStorage.removeItem("role");

					// Vérifier si le toast n'est pas déjà affiché
					if (!toast.isActive('accountDisabled')) {
						toast({
							id: 'accountDisabled',
							description: t("le compte est désactivé"),
							status: 'warning',
							variant: 'left-accent',
							duration: 2000,
							isClosable: true,
							position: 'bottom-right'
						});
					}
					return;
				}

				setTicketsOldCount(response.data.old_count);
				setTicketsNewCount(response.data.new_count);
			})
			.catch((error) => {
				// console.log(error);
			});
	}
	const fetchCommandes = () => {
		setLoadingData(true)
		axiosClient.get(`/commandes/fetch_month_commandes/?page_size=${pageSize}&page=${currentPage + 1}&client=${user.id}&business=${currentBusiness?.id}`)
			.then((response) => {
				let filteredCmd = response.data.results || []
				setPaginationData(response.data);

				if (filteredCmd.length === 0) {
					setCheckLengthData(true)
				}
				else {
					setCommandes(filteredCmd);
				}
				setLoadingData(false)

				if (response.data.error === 'Client is disabled.' && response.data.etat === false) {
					setUser({});
					setToken(null);
					localStorage.removeItem("tokenExpirationTime");
					localStorage.removeItem("refreshTimeAdmin");
					localStorage.removeItem("role");

					// Vérifier si le toast n'est pas déjà affiché
					if (!toast.isActive('accountDisabled')) {
						toast({
							id: 'accountDisabled',
							description: t("le compte est désactivé"),
							status: 'warning',
							variant: 'left-accent',
							duration: 2000,
							isClosable: true,
							position: 'bottom-right'
						});
					}
				}
			})
			.catch((error) => {
				// // console.error(error);
				setLoadingData(false)
			});
		axiosClient.get(`count_commandes_livre_this_month/${user.id}/?business=${currentBusiness?.id}`)
			.then((response) => {

				if (response.data.error === 'Client is disabled.' && response.data.etat === false) {
					setUser({});
					setToken(null);
					localStorage.removeItem("tokenExpirationTime");
					localStorage.removeItem("refreshTimeAdmin");
					localStorage.removeItem("role");

					// Vérifier si le toast n'est pas déjà affiché
					if (!toast.isActive('accountDisabled')) {
						toast({
							id: 'accountDisabled',
							description: t("le compte est désactivé"),
							status: 'warning',
							variant: 'left-accent',
							duration: 2000,
							isClosable: true,
							position: 'bottom-right'
						});
					}
					return
				}

				setCountLivreThisMonth(response.data.count);
			})
			.catch((error) => {
				// console.log(error);
			});

	}
	const fetchTop10Products = () => {
		axiosClient.get(`top_products/${user.id}/?business=${currentBusiness?.id}`)
			.then((response) => {

				if (response.data.error === 'Client is disabled.' && response.data.etat === false) {
					setUser({});
					setToken(null);
					localStorage.removeItem("tokenExpirationTime");
					localStorage.removeItem("refreshTimeAdmin");
					localStorage.removeItem("role");

					// Vérifier si le toast n'est pas déjà affiché
					if (!toast.isActive('accountDisabled')) {
						toast({
							id: 'accountDisabled',
							description: t("le compte est désactivé"),
							status: 'warning',
							variant: 'left-accent',
							duration: 2000,
							isClosable: true,
							position: 'bottom-right'
						});
					}
					return;
				}

				setTop10products(response.data);
			})
			.catch((error) => {
				// console.log(error);
			});


	}

	const [lineChartData, setLineChartData] = useState(null);

	useEffect(() => {
		if (user?.id) {
			const fetchData = async () => {
				try {
					const data = await lineChartDataDashboard();
					setLineChartData(data);
				} catch (error) {
					// // console.error('Error fetching data:', error);
				}
			};

			fetchData();
		}
	}, [user?.id, currentBusiness?.id]);

	useEffect(() => {
		if (user?.id) {
			fetchData()
			fetchTop10Products()
			fetchBarData(user?.id, user?.role)
		}
	}, [user?.id, currentBusiness?.id]);

	useEffect(() => {
		if (user?.id) {
			fetchCommandes()
		}
	}, [user?.id, currentBusiness?.id, currentPage, pageSize]);

	useEffect(() => {
		setCurrentPage(0);
		setCurrentPageTop10(0);
	}, [currentBusiness?.id]);

	return (
		<Flex mt={5} flexDirection='column' >

			<SimpleGrid columns={{ sm: 1, md: 2, xl: 4 }} spacing='24px'>
				{/* MiniStatistics Card */}
				<Card rounded={"xl"} bg={useColorModeValue("white", "gray.700")}>
					<CardBody>
						<Flex flexDirection='row' align='center' justify='center' w='100%'>
							<Stat me='auto'>
								<StatLabel fontSize='sm' color='gray.400' fontWeight='bold' pb='2px'>
									{t("Nombre de personnels")}
								</StatLabel>
								<Flex>
									{(usersOldCount !== 0 || usersNewCount === 0) &&
										<StatNumber fontSize='lg' color='blue.700' fontWeight='bold'>
											{usersOldCount}
										</StatNumber>
									}

									{usersNewCount > 0 &&
										<StatHelpText
											alignSelf='flex-end'
											justifySelf='flex-end'
											m='0px'
											color='green.400'
											fontWeight='bold'
											ps='3px'
											fontSize='md'>
											+ {usersNewCount}
										</StatHelpText>}


								</Flex>
							</Stat>
							<IconBox as='box' h={'45px'} w={'45px'} bg='teal.300'>
								<FaUserGroup size={"25px"} color='white' />
							</IconBox>
						</Flex>
					</CardBody>
				</Card>
				{/* MiniStatistics Card */}
				<Card rounded={"xl"} bg={useColorModeValue("white", "gray.700")} minH='83px'>
					<CardBody>
						<Flex flexDirection='row' align='center' justify='center' w='100%'>
							<Stat me='auto'>
								<StatLabel fontSize='sm' color='gray.400' fontWeight='bold' pb='2px'>
									{t("Nombre de commandes")}
								</StatLabel>
								<Flex>
									{(commandesOldCount !== 0 || commandesNewCount === 0) &&
										<StatNumber fontSize='lg' color='blue.700' fontWeight='bold'>
											{commandesOldCount}
										</StatNumber>
									}

									{commandesNewCount > 0 &&
										<StatHelpText
											alignSelf='flex-end'
											justifySelf='flex-end'
											m='0px'
											color='green.400'
											fontWeight='bold'
											ps='3px'
											fontSize='md'>
											+ {commandesNewCount}
										</StatHelpText>
									}


								</Flex>
							</Stat>
							<IconBox as='box' h={'45px'} w={'45px'} bg='red.300'>
								<FaUserTie size={"25px"} color='white' />
							</IconBox>
						</Flex>
					</CardBody>
				</Card>
				{/* MiniStatistics Card */}
				<Card rounded={"xl"} bg={useColorModeValue("white", "gray.700")}>
					<CardBody>
						<Flex flexDirection='row' align='center' justify='center' w='100%'>
							<Stat>
								<StatLabel fontSize='sm' color='gray.400' fontWeight='bold' pb='2px'>
									{t("Nombre de produits")}
								</StatLabel>
								<Flex>
									{(productsOldCount !== 0 || productsNewCount === 0) &&
										<StatNumber fontSize='lg' color='blue.700' fontWeight='bold'>
											{productsOldCount}
										</StatNumber>
									}

									{productsNewCount > 0 &&
										<StatHelpText
											alignSelf='flex-end'
											justifySelf='flex-end'
											m='0px'
											color='green.400'
											fontWeight='bold'
											ps='3px'
											fontSize='md'>
											+ {productsNewCount}
										</StatHelpText>
									}


								</Flex>
							</Stat>
							<IconBox as='box' h={'45px'} w={'45px'} bg='blue.300'>
								<IoDocument size={"25px"} color='white' />
							</IconBox>
						</Flex>
					</CardBody>
				</Card>
				{/* MiniStatistics Card */}
				<Card rounded={"xl"} bg={useColorModeValue("white", "gray.700")}>
					<CardBody>
						<Flex flexDirection='row' align='center' justify='center' w='100%'>
							<Stat me='auto'>
								<StatLabel fontSize='sm' color='gray.400' fontWeight='bold' pb='2px'>
									{t("Réclamations")}
								</StatLabel>
								<Flex>
									{(ticketsOldCount !== 0 || ticketsNewCount === 0) &&
										<StatNumber fontSize='lg' color='blue.700' fontWeight='bold'>
											{ticketsOldCount}
										</StatNumber>
									}

									{ticketsNewCount > 0 &&
										<StatHelpText
											alignSelf='flex-end'
											justifySelf='flex-end'
											m='0px'
											color='green.400'
											fontWeight='bold'
											ps='3px'
											fontSize='md'>
											+ {ticketsNewCount}
										</StatHelpText>
									}

								</Flex>
							</Stat>
							<IconBox as='box' h={'45px'} w={'45px'} bg='yellow.400'>
								<BsPersonVcardFill size={"25px"} color='white' />
							</IconBox>
						</Flex>
					</CardBody>
				</Card>
			</SimpleGrid>
			<Grid
				templateColumns={{ sm: '1fr', lg: '1.7fr 1.3fr' }}
				maxW={{ sm: '100%', md: '100%' }}
				gap='24px'
				my='26px'>
				{/* Sales Overview */}
				<Card rounded={'xl'} p='10px '>
					<CardHeader ps='22px'>
						<Flex direction='column' alignSelf='flex-start'>
							<Text fontSize='lg' fontWeight='bold' mb='6px'>
								{t("Évolution des Revenus et des Charges")}
							</Text>
							{/* <Text fontSize='md' fontWeight='medium' color='gray.400'>
								<Text as='span' color='green.400' fontWeight='bold'>
									(+5%) more
								</Text>{' '}
								in 2021
							</Text> */}
						</Flex>
					</CardHeader>
					<Box w='100%' minH={{ base: '200px', sm: "300px" }}>
						{lineChartData &&
							<LineChart
								lineChartData={lineChartData}
								lineChartOptions={lineChartOptionsDashboard}
							/>}

					</Box>
				</Card>
				{/* Active Users */}
				<Card rounded={'xl'} p={{ base: "5px", md: "15px" }}>
					<CardBody>
						<Flex direction='column' w='100%'>
							<Box
								bg={useColorModeValue('linear-gradient(71deg, rgba(255,255,255,1) 0%, rgba(239,229,253,1) 53%, rgba(214,188,250,1) 100%)', 'linear-gradient(71deg, rgba(50,62,81,1) 0%, rgba(65,49,117,1) 100%)')}
								borderRadius='20px'
								shadow={'xl'}
								w='100%'

								// minH={{ sm: '300px' }}
								display={{ sm: 'flex', md: 'block' }}
								justify={{ sm: 'center', md: 'flex-start' }}
								align={{ sm: 'center', md: 'flex-start' }}
								minH={{ base: '180px', md: '220px' }}
								p={{ base: '15px', sm: "20px", md: '22px' }}>
								{/* <BarChart

									barChartOptions={barChartOptionsDashboard}
									barChartData={barChartDataDashboard}
								/> */}
								<Bar data={dataChart} options={options} />
							</Box>
							<Flex direction='column' mt='24px' mb='10px' alignSelf='flex-start'>
								<Text fontSize='lg' fontWeight='bold' mb='6px'>
									{t("Statuts de commandes")}
								</Text>
								{/* <Text fontSize='md' fontWeight='medium' color='gray.400'>
									<Text as='span' color='green.400' fontWeight='bold'>
										(+23%)
									</Text>{' '}
									than last week
								</Text> */}
							</Flex>
							<SimpleGrid gap={{ base: "12px", sm: '12px' }} columns={{ base: 2, md: 4 }}>
								<Flex direction='column'>
									<Flex alignItems='center'>
										<IconBox as='box' h={'30px'} w={'30px'} bg='brand.200' me='6px'>
											<MdOutlineAddShoppingCart size={"23px"} />
										</IconBox>
										<Text fontSize='sm' color='gray.400'>
											{t("Nouveau")}
										</Text>
									</Flex>
									<Text
										fontSize={{ sm: 'md', lg: 'lg' }}

										fontWeight='bold'
										mb='6px'
										my='6px'>
										{countNew}
									</Text>
									<Progress colorScheme='brand' bg='blue.300' borderRadius='30px' h='5px' value={20} />
								</Flex>
								<Flex direction='column'>
									<Flex alignItems='center'>
										<IconBox as='box' h={'30px'} w={'30px'} bg='brand.200' me='6px'>
											<TbTruckDelivery size={"23px"} />
										</IconBox>
										<Text fontSize='sm' color='gray.400'>
											{t("Livrée")}
										</Text>
									</Flex>
									<Text
										fontSize={{ sm: 'md', lg: 'lg' }}

										fontWeight='bold'
										mb='6px'
										my='6px'>
										{countLivre}
									</Text>
									<Progress colorScheme='brand' bg='purple.300' borderRadius='30px' h='5px' value={90} />
								</Flex>
								<Flex direction='column'>
									<Flex alignItems='center'>
										<IconBox as='box' h={'30px'} w={'30px'} bg='brand.200' me='6px'>
											<TbTruckReturn size={"23px"} />
										</IconBox>
										<Text fontSize='sm' color='gray.400'>
											{t("Retournée")}
										</Text>
									</Flex>
									<Text
										fontSize={{ sm: 'md', lg: 'lg' }}

										fontWeight='bold'
										mb='6px'
										my='6px'>
										{countRetour}
									</Text>
									<Progress colorScheme='brand' bg='orange.300' borderRadius='30px' h='5px' value={30} />
								</Flex>
								<Flex direction='column'>
									<Flex alignItems='center'>
										<IconBox as='box' h={'30px'} w={'30px'} bg='brand.200' me='6px'>
											<LuPackageX size={"23px"} />
										</IconBox>
										<Text fontSize='sm' color='gray.400'>
											{t("Annulée")}
										</Text>
									</Flex>
									<Text
										fontSize={{ sm: 'md', lg: 'lg' }}

										fontWeight='bold'
										mb='6px'
										my='6px'>
										{countAnnule}
									</Text>
									<Progress colorScheme='brand' bg='red.300' borderRadius='30px' h='5px' value={50} />
								</Flex>
							</SimpleGrid>
						</Flex>
					</CardBody>
				</Card>
			</Grid>

			<Grid templateColumns={{ sm: '1fr', md: '1fr 1fr', lg: '2fr 1fr' }} gap='24px'>
				{/* Projects */}
				<Card rounded={'xl'} p='16px' overflowX={{ sm: 'scroll', xl: 'hidden' }}>
					<CardHeader p='12px 0px 20px 0px'>
						<Flex direction='column'>
							<Text fontSize='lg' fontWeight='bold' pb='8px'>
								{t("Les commandes livrées")}
							</Text>
							<Flex align='center'>
								<Icon as={IoCheckmarkDoneCircleSharp} color='teal.300' w={4} h={4} pe='3px' />
								<Text fontSize='sm' color='gray.400' fontWeight='normal'>
									<Text fontWeight='bold' as='span'>
										{countLivreThisMonth} {t("Livrées")}
									</Text>{' '}
									{t("ce mois.")}
								</Text>
							</Flex>
						</Flex>
					</CardHeader>
					<TableContainer pb={5}>
						<Table size={"md"} variant='simple'>
							<Thead>
								<Tr my='.8rem' ps='0px'>
									<Th
										fontSize={"sm"}
										ps='0px'
										color='gray.500'
										fontFamily='Plus Jakarta Display'
										borderBottomColor='#56577A'>
										{t("Code commande")}
									</Th>
									<Th fontSize={"sm"} color='gray.500' fontFamily='Plus Jakarta Display' borderBottomColor='#56577A'>
										Client
									</Th>
									<Th fontSize={"sm"} color='gray.500' fontFamily='Plus Jakarta Display' borderBottomColor='#56577A'>
										{t("Gestionnaire")}
									</Th>
									<Th fontSize={"sm"} color='gray.500' fontFamily='Plus Jakarta Display' borderBottomColor='#56577A'>
										{t("Prix")}
									</Th>

								</Tr>
							</Thead>
							<Tbody>
								{loadingData &&
									<Tr>

										<Td> <Skeleton height='20px' /></Td>
										<Td> <Skeleton height='20px' /></Td>
										<Td> <Skeleton height='20px' /></Td>
										<Td> <Skeleton height='20px' /></Td>

									</Tr>}
								{(paginationData?.length !== 0) && commandes.map((row) =>
									<Tr my='.8rem' ps='0px'>
										<Td ps='0px'>{row.code}</Td>
										<Td >
											<Flex gap={2} direction='column'>
												<Text
													fontSize='sm'

													fontWeight='normal'
													minWidth='100%'>
													{row.full_name}
												</Text>
												<Text fontSize='sm' color='gray.500' fontWeight='normal'>
													{row.tel}
												</Text>
											</Flex>
										</Td>

										<Td >
											<Flex gap={2} align={"center"}>
												<Avatar size={"sm"} name='Dan Abrahmov' src={row.image} />
												<Flex gap={1} direction={"column"}>
													<Text>{row.gst_first_name} </Text>
													<Text>{row.gst_last_name}</Text>
												</Flex>
											</Flex>
										</Td>
										<Td   >
											<Flex gap={1}>
												<Text fontWeight={"semibold"}  >{(row.prix * exchangeRate).toFixed(2)}</Text> <Text h={"100%"} fontSize={12} >{currentBusiness?.currency}</Text>
											</Flex>

										</Td>
									</Tr>
								)}
								{(commandes?.length === 0) && (
									<Tr>
										<Td colSpan={11}>{t("il n'y a pas encore de données.")}</Td>
									</Tr>
								)}




								{/* {dashboardTableData.map((row, index, arr) => {
								return (
									<DashboardTableRow
										name={row.name}
										logo={row.logo}
										members={row.members}
										budget={row.budget}
										progression={row.progression}
										lastItem={index === arr.length - 1 ? true : false}
									/>
								);
							})} */}
							</Tbody>
						</Table>

					</TableContainer>
					{commandes?.length > 0 &&
						<Flex justify="space-between" align="center" w="100%">
							<Box flex="1">
								<MyPagination
									paginationData={paginationData}
									currentPage={currentPage}
									setCurrentPage={setCurrentPage}
									PAGE_SIZE={pageSize}
								/>
							</Box>
						</Flex>
					}


				</Card>
				{/* Orders Overview */}
				<Card rounded={'xl'} p='16px' overflowX={{ sm: 'scroll', xl: 'hidden' }}>
					<CardHeader p='12px 0px 20px 0px'>
						<Flex direction='column'>
							<Text fontSize='lg' fontWeight='bold' pb='8px'>
								Top 10 {t("produits")}
							</Text>
							<Flex align='center'>
								<Icon as={IoCheckmarkDoneCircleSharp} color='teal.300' w={4} h={4} pe='3px' />
								<Text fontSize='sm' color='gray.400' fontWeight='normal'>
									<Text fontWeight='bold' as='span'>
										{t("basé sur les produits livrés")}
									</Text>
								</Text>
							</Flex>
						</Flex>
					</CardHeader>
					{top10Products.slice(currentPageTop10 * pageSizeTop10, currentPageTop10 * pageSizeTop10 + pageSizeTop10).map((row) => (
						<Card cursor={"pointer"} transition={"transform .3s"} mb={2} _hover={{
							shadow: "lg",
							transform: "scale(1.05)",
						}} shadow={'none'}>
							<CardBody alignItems={"center"} display={"flex"} justifyContent={"space-between"} p={2}>
								<Flex align={"center"} gap={2}>
									<Avatar borderRadius={"md"} name='Dan Abrahmov' src={linkImage + row.image} />
									<Flex fontSize={'sm'} direction={"column"}>
										<Text>{row.title}</Text>
										<Text color='gray' fontSize={"xs"}>{row.code}</Text>
									</Flex>
								</Flex>
								<Badge rounded={"lg"} px={4} py={1} variant='subtle' colorScheme='purple'>
									{row.count}
								</Badge>
							</CardBody>
						</Card>
					))}
					{top10Products?.length > 0 ?
						<Flex justify="space-between" align="center" w="100%">
							<Box flex="1">
								<SimplePagination
									data={top10Products}
									PAGE_SIZE={pageSizeTop10}
									currentPage={currentPageTop10}
									setCurrentPage={setCurrentPageTop10}
								/>
							</Box>


						</Flex>
						:
						<Flex my={'5'} align={'center'} justify={'center'}>
							<Image
								opacity={0.1}
								height={100} width={150}
								rounded={'md'}
								alt={'empty'}
								src={
									empty
								}
								objectFit={'empty'}
							/>
						</Flex>
					}



				</Card>
			</Grid>
		</Flex>
	)
}

export default Dashboard